module.exports = __webpack_public_path__ + "static/media/bg-3-features.1293d3c2.svg";